import React, { useState } from 'react';
import { LIVEDETECT_BASE as BASE } from './useLatestDetection';
import LiveDetectLightbox from './LiveDetectLightbox';
import '../css/recentDetections.css';

const MAX_ITEMS = 5;

const fmtEpoch = (epochS) => {
  if (!epochS) return '';
  try {
    return new Date(epochS * 1000).toLocaleString('de-DE', {
      timeZone: 'Europe/Berlin',
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
};

const fmtTime = (epochS) => {
  if (!epochS) return '';
  try {
    return new Date(epochS * 1000).toLocaleString('de-DE', {
      timeZone: 'Europe/Berlin',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
};

const RecentDetectionsStrip = ({ index, onShowAll }) => {
  const [lightbox, setLightbox] = useState(null);

  if (!index) return null;
  if (!index.groups || index.groups.length === 0) return null;

  const recent = index.groups.slice(0, MAX_ITEMS);

  return (
    <>
      <div className="recent-detections">
        <div className="recent-detections-header">
          <span className="recent-detections-title">
            <i className="fa fa-eye"></i> Letzte Erkennungen
            <span className="recent-detections-count">{index.group_count}</span>
          </span>
          <button className="recent-detections-all" onClick={onShowAll}>
            Alle anzeigen <i className="fa fa-arrow-right"></i>
          </button>
        </div>
        <div className="recent-detections-strip">
          {recent.map(group => (
            <button
              key={group.id}
              className="recent-detection-thumb"
              onClick={() => {
                const bestIdx = group.frames.findIndex(f => f.image === group.best.image);
                setLightbox({ frames: group.frames, initialIndex: bestIdx >= 0 ? bestIdx : 0 });
              }}
              title={`${fmtEpoch(group.start_epoch)} — ${Math.round(group.best.confidence * 100)}%`}
            >
              <img src={`${BASE}/ring/${group.best.image}`} alt="" />
              <span className="recent-detection-time">{fmtTime(group.start_epoch)}</span>
              <span className="recent-detection-conf">{Math.round(group.best.confidence * 100)}%</span>
            </button>
          ))}
        </div>
      </div>

      <LiveDetectLightbox
        frames={lightbox?.frames}
        initialIndex={lightbox?.initialIndex || 0}
        onClose={() => setLightbox(null)}
      />
    </>
  );
};

export default RecentDetectionsStrip;
